import React, { useState } from "react";


const NavbarTab = ({tabs}) => {
  const [openTabIndex, setOpenTabIndex] = useState(0);

  const tabContents = <>{
    tabs.map((t,idx) => 
      (idx == openTabIndex || t.alwaysRender) && 
      <div key={`tab-content-${idx}`} className={`tab-content ${idx == openTabIndex ? '' : 'invisible'}`}>
        {t.content}
      </div>
    )
  }</>

  return <div>
    <ul className="project-title-tabs">
      {tabs.map((tab, idx) => (
      <li
        key={`tab-${idx}`}
        className={`${openTabIndex == idx ? 'selected' : ''}`}
        onClick={() => setOpenTabIndex(idx)}
      >
        {tab.title}
      </li>))}
    </ul>    
    {tabContents}
  </div>
}

export default NavbarTab;